export default __webpack_public_path__ + "static/media/Demontongue.29c28113.jpg";